import React from "react";
import {orange} from "@material-ui/core/colors";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const WarningIcon = ({
  width = 18,
  height = 15,
  className,
  color = orange["500"],
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 0.5L0.75 14.75H17.25L9 0.5ZM9 3.5L14.6475 13.25H3.3525L9 3.5ZM8.25 6.5V9.5H9.75V6.5H8.25ZM8.25 11V12.5H9.75V11"
        fill={color}
      />
    </svg>
  );
};

export default WarningIcon;
